module.exports = __webpack_public_path__ + "static/media/Ginkgo-Biloba.03571770.jpg";